// export const BaseUrl = "http://localhost:5000";
export const BaseUrl = "https://tattqrbe-production.up.railway.app";
